import { TicketUpgradeCardPropsType } from "./type";
import useNavigateWrapper from "shared/hooks/useNavigateWrapper";
import React from "react";
import { generatePath } from "react-router-dom";
import { MyExpRoute } from "../../../routes/types";

export default function useTicketUpgradeCardService(props: TicketUpgradeCardPropsType) {
  const { navigate } = useNavigateWrapper();
  const isCurrentTicket = React.useMemo(() => {
    return props.ticketDetails.id === props.currentTicketDetails.id;
  }, [props.currentTicketDetails.id, props.ticketDetails.id]);

  const hasPriceDifference = React.useMemo(() => {
    return props.ticketDetails.currentPrice?.value !== props.ticketDetails.priceDifference?.value;
  }, [props.ticketDetails]);

  const buyTicketClickHandler = React.useCallback(() => {
    navigate(
      generatePath(`/${MyExpRoute.TICKET_CHANGE.path}/${MyExpRoute.TICKET_CHANGE.FORM_DETAILS.path}`, {
        formId: props.ticketDetails.id
      })
    );
  }, [navigate, props.ticketDetails.id]);

  return { isCurrentTicket, hasPriceDifference, buyTicketClickHandler };
}
